/* Diver Bubbles — mega menu: open on hover, close when the pointer leaves.
   Loaded on EVERY page via snippets/header-mega-menu.liquid (the homepage
   also binds this from db-home.js; the per-<details> guard keeps it idempotent).
   A closed <details> renders no content, so hover toggles the [open] attribute
   directly; the open animation lives in db-mega.css. Mouse clicks on the label
   are neutralised so a click can't stick the panel; keyboard/touch stay native. */
(function () {
  if (window.__dbMegaHover) return;
  window.__dbMegaHover = true;

  var finePointer = window.matchMedia('(pointer: fine)').matches;

  function bind() {
    if (!finePointer) return;
    document.querySelectorAll('.header__inline-menu details.mega-menu').forEach(function (details) {
      if (details.dataset.dbHoverBound) return;
      details.dataset.dbHoverBound = '1';
      var summary = details.querySelector('summary');
      var li = details.closest('li') || details;
      var closeTimer = null;
      var openNow = function () {
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        document.querySelectorAll('.header__inline-menu details.mega-menu[open]').forEach(function (d) {
          if (d !== details) d.removeAttribute('open');
        });
        if (!details.hasAttribute('open')) details.setAttribute('open', '');
      };
      var closeSoon = function () {
        if (closeTimer) clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          details.removeAttribute('open');
          closeTimer = null;
        }, 140); /* grace period for the summary -> panel gap */
      };
      li.addEventListener('mouseenter', openNow);
      li.addEventListener('mouseleave', closeSoon);
      if (summary) {
        summary.addEventListener('mousedown', function (e) { e.preventDefault(); });
        summary.addEventListener('click', function (e) { if (e.detail !== 0) e.preventDefault(); });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
  document.addEventListener('shopify:section:load', bind);
})();

/* Water-ripple pointer tracking for the hero CTAs — writes the cursor
   position into --rx/--ry; db-mega.css draws the expanding rings. Also
   injects an SVG turbulence/displacement filter (#db-water) so the waves
   visibly DISTORT the button surface on hover; db-mega.css only applies
   the filter when <html> carries .db-water, so a missing filter can never
   blank the buttons. */
(function () {
  if (window.__dbRipple) return;
  window.__dbRipple = true;
  if (!window.matchMedia('(pointer: fine)').matches) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ensureWaterFilter() {
    if (reduced) return;
    if (!document.getElementById('db-water-defs')) {
      /* Build the SVG through a plain <div> innerHTML: the HTML parser applies
         foreign-content rules to <svg>, so the filter primitives land in the
         real SVG namespace and actually run (setting innerHTML directly on a
         createElementNS'd <svg> is unreliable across browsers). */
      var wrap = document.createElement('div');
      wrap.id = 'db-water-defs';
      wrap.setAttribute('aria-hidden', 'true');
      wrap.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden';
      wrap.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="0" height="0">' +
        '<filter id="db-water" x="-35%" y="-60%" width="170%" height="220%">' +
        '<feTurbulence type="fractalNoise" baseFrequency="0.008 0.02" numOctaves="1" seed="7" result="n">' +
        '<animate attributeName="baseFrequency" dur="6s" values="0.008 0.02;0.013 0.03;0.008 0.02" repeatCount="indefinite"/>' +
        '</feTurbulence>' +
        /* feDisplacementMap samples the noise map per pixel and anti-aliases nothing, so any
           fine detail left in the map lands on the edge as sawtooth. Blur the MAP first: that
           removes the spike source. scale rises because blurring also flattens the amplitude. */
        '<feGaussianBlur in="n" stdDeviation="2" result="nb"/>' +
        '<feDisplacementMap in="SourceGraphic" in2="nb" scale="30" xChannelSelector="R" yChannelSelector="G" result="d"/>' +
        /* Then blur + alpha-contrast the RESULT (the metaball trick #db-goo already uses): the
           blur rounds off whatever is still sharp, the matrix snaps alpha back to a clean contour
           so the edge reads liquid, not fuzzy. Safe only because ::before is a flat solid fill. */
        '<feGaussianBlur in="d" stdDeviation="2" result="db"/>' +
        '<feColorMatrix in="db" type="matrix" values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 10 -4.5"/>' +
        '</filter></svg>';
      document.body.appendChild(wrap);
    }
    document.documentElement.classList.add('db-water');
  }

  function bindRipple() {
    /* hero CTAs (flare + ghost) plus every red flare CTA site-wide (showcase, printlab...) */
    var btns = document.querySelectorAll('.db-hero .db-btn, .db-btn--flare');
    if (!btns.length) return;
    ensureWaterFilter();
    btns.forEach(function (btn) {
      if (btn.dataset.dbRippleBound) return;
      btn.dataset.dbRippleBound = '1';
      btn.addEventListener('pointermove', function (e) {
        var r = btn.getBoundingClientRect();
        btn.style.setProperty('--rx', (e.clientX - r.left).toFixed(1) + 'px');
        btn.style.setProperty('--ry', (e.clientY - r.top).toFixed(1) + 'px');
      }, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindRipple);
  } else {
    bindRipple();
  }
  document.addEventListener('shopify:section:load', bindRipple);
})();
